import { gql } from '@apollo/client';

/**
 * GraphQL mutation for updating a community group
 */
export const UPDATE_COMMUNITY_GROUP = gql`
  mutation UpdateCommunityGroup($id: ID!, $input: UpdateCommunityGroupInput!) {
    updateCommunityGroup(id: $id, input: $input) {
      id
      name
      description
      securityGroups {
        admin
        moderator
        user
      }
    }
  }
`;
